import NotInformation from "../../../../../../components/NotInformation";
import {permissionObj} from "../../../../../../Helpers/permission";
import CustomButtonLink from "../../../../../../components/buttons/CustomButtonLink";
import routes from "../../../../../../Routes/routes";
import CustomTooltip from "../../../../../../components/CustomTooltip";
import CustomSortableList from "../../../../../../components/CustomSortableList";
import DraggableCard from "../../../../Traffic/Manage/SubComponents/DraggableCard";
import CustomAccordion from "../../../../../../components/Accordion/CustomAccordion";
import GeofenceCardHeader from "../../../../Traffic/Manage/SubComponents/GeofenceCardHeader";
import {CustomSwitch} from "../../../../../../components/CustomSwitch";
import {STATUS_MODEL} from "../../../../../../enums/statusEnum";
import GeofencesMap from "../../../../Traffic/Manage/SubComponents/GeofencesMap";
import DeleteModal from "../../../../../Modals/DeleteModal";
import ConfirmModal from "../../../../Visitor/Invitation/Modal/ConfirmModal";
import React from "react";
import GeofenceCardBody from "./SubComponents/GeofenceCardBody";
import {ATTENDANCE_GEOFENCE_MODE} from "./Model/Model";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 21 de 01 de 2026
 */

const GeofenceMap = ({
                         t,
                         DEV,
                         goUrl,
                         center,
                         expanded,
                         selected,
                         dayArray,
                         geofences,
                         direction,
                         permission,
                         setExpanded,
                         setSelected,
                         setGeofences,
                         handleMapMove,
                         deleteModalShow,
                         getActionsButtons,
                         setDeleteModalShow,
                         handleUpdateStatus,
                         handleDeleteSelected,
                         showActiveInactiveModal,
                         setShowActiveInactiveModal,
                         handleUpdateHierarchyLevel
                     }) => {

    return (
        <>
            <>
                <div className={"row"}  >
                    { geofences.length === 0?
                        <NotInformation card={true}>
                            <>
                                <div className="warning-text">
                                    <p>{t("you_have_not_created_any_geofences_yet")}</p>
                                </div>
                                { (DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_MANAGE_GEOFENCES_CREATE)) &&
                                <CustomButtonLink
                                    splitName={false}
                                    id="btn_gm_create"
                                    card={true}
                                    onClick={() => goUrl(routes.attendanceGeofence.create)}
                                    name="create_new_geofence"
                                />
                                }

                            </>
                        </NotInformation>
                        :
                        <div className={"border-full-shades-100 border-radius-8px"}>
                            <div className={"row my-4"}>
                                <div className='col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4'>
                                    <div className={"col-12 gap-3 h-36px"}>
                                        <CustomTooltip
                                            text={direction}
                                            classes={"pl-0 fs-12px ibl-font-w-500 font-color-primary-700 text-ellipsis-2-rows text-break-wrap"}
                                            showIfTruncated={true}
                                            placement={"top"}
                                        />
                                    </div>
                                    <div className='border-bottom-shades-300 mb-2'/>

                                    <CustomSortableList
                                        keyId={"geofenceId"}
                                        items={geofences}
                                        setItems={setGeofences}
                                        onSortEnd={(data) => {
                                            handleUpdateHierarchyLevel(data)
                                        }}
                                        renderItem={(geofence, index, isDragging) => {
                                            const backgroundColor = isDragging ? 'card-accent-50' : 'background-shades-50';
                                            const transparent = 'card-transparent';

                                            return <DraggableCard
                                                item={geofence.hierarchyLevel}
                                                setSelectItem={setSelected}
                                                setDeleteModalShow={setDeleteModalShow}
                                                backgroundColor={`${backgroundColor} border-radius-8px`}
                                                className={"mb-2"}
                                                body={
                                                    <CustomAccordion
                                                        title={`draggable_card_${geofence?.geofenceId}`}
                                                        currentKey={geofence?.geofenceId}
                                                        activeKey={expanded}
                                                        backgroundColorHeader={'card-accent-50'}
                                                        onClick={() => setExpanded(prev => !prev ? geofence?.geofenceId: null)}
                                                        header={<GeofenceCardHeader geofence={geofence} backgroundColor={transparent}/>}
                                                        subtitle={
                                                            <div className={"mt-2"}>
                                                                <p className={"fs-14px font-color-shades-500 ibl-font-w-400"}>{t(ATTENDANCE_GEOFENCE_MODE.getById(geofence?.mode)?.trans)?.toUpperCase()}</p>
                                                            </div>
                                                        }
                                                        button={getActionsButtons({geofence, transparent})}
                                                        classNameHeader={"border-bottom-shades-300"}
                                                        classNameContainer={`shadow-none border-0 ${transparent}`}
                                                        classNameAccordionItem={`shadow-none border-0 ${transparent}`}
                                                        classNameAccordionButton={transparent}
                                                        classNameAccordionBody={`${transparent} p-0`}
                                                    >
                                                        <GeofenceCardBody
                                                            geofence={geofence}
                                                            backgroundColor={backgroundColor}
                                                            dayArray={dayArray}
                                                        />
                                                    </CustomAccordion>
                                                }
                                                footer={
                                                    <div className='col-12 p-0'>
                                                        <CustomSwitch
                                                            id='cs_gm_status_switch'
                                                            checked={geofence?.statusId === STATUS_MODEL.ACTIVE_COMPANY}
                                                            showBorder={false}
                                                            onChange={() => {
                                                                setSelected(geofence)
                                                                setShowActiveInactiveModal(true)
                                                            }}
                                                            disabled={!DEV && !permission?.includes(permissionObj?.WEB_ATTENDANCE_MANAGE_GEOFENCES_UPDATE)}
                                                        />
                                                    </div>
                                                }
                                            />
                                        }}
                                    />
                                </div>
                                <div className='col-sm-12 col-md-6 col-lg-8 col-xl-8 col-xxl-8' >
                                    {center && geofences?.length > 0 &&
                                        <GeofencesMap
                                            center={center}
                                            geofences={geofences}
                                            zoom={11}
                                            onMapMove={handleMapMove}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
                {deleteModalShow && (
                    <DeleteModal
                        show={deleteModalShow}
                        onHide={() => setDeleteModalShow(false)}
                        onClickFn={() => {
                            handleDeleteSelected();
                        }}
                        data={[selected]}
                        title_modal={t('delete_geofence')}
                        element_modal={t('geofence')}
                        buttonCancelText={'cancel'}
                    />
                )}

                <ConfirmModal
                    show={showActiveInactiveModal}
                    onHide={() => setShowActiveInactiveModal(false)}
                    onClickFn={() => {
                        handleUpdateStatus();
                        setShowActiveInactiveModal(false);
                    }}
                    title_modal={parseInt(selected?.statusId) === STATUS_MODEL.ACTIVE_COMPANY ? 'deactivate_geofence':
                        'activate_geofence'}
                    description={parseInt(selected?.statusId) === STATUS_MODEL.ACTIVE_COMPANY ? t("are_you_sure_you_want_to_deactivate_the_geofence"):
                        t("are_you_sure_you_want_to_activate_the_geofence")}
                />
            </>
        </>
    )
}

export default GeofenceMap
